export default String.raw`
.after-adding-to-popup {
    max-height: 100svh;
    height: fit-content;

    .dialog {
        &__content {
            padding: 24px 16px 0 16px;

            .products__list-item {
                gap: 8px;
            }
            .product__attribute .key {
                display: none;
            }
            .product__price {
                white-space: break-spaces;
            }
        }

        &__actions {
            padding: 16px;
            justify-content: center;
            flex-direction: column-reverse;
            gap: 12px;
        }
    }
}

.after-adding-to-cart-popup:has(.ai-recommended-js) {
    max-height: 100svh;
    height: fit-content;
}
`